import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AuthService } from '@services';
import { Permission } from '@models';
import { environment } from '@environment';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';

export const datasetPermissionResolver: ResolveFn<Permission | null> = (route: ActivatedRouteSnapshot) => {
  const datasetId = route.data['datasetId'] || route.paramMap.get('id');
  if (!datasetId) {
    return null;
  }

  const authService = inject(AuthService);
  const user = authService.user();
  if (!user) {
    return null;
  }

  const http = inject(HttpClient);

  return http.get<Permission>(`${environment.kinkoHost}/dataset/${datasetId}/permission/${user.id}`).pipe(
    catchError(() => {
      return of(null);
    }),
  );
}
